import { Feature, getFeatureFlag } from '../models/features/features';
import { usePatronSelector } from './use-patron-selector';

//refactored to only take 1 flag at a time to make mocking easier.
//we dont use multiple flags in enough places to make this worth it.
export function useFeatureFlag(
  flag: Feature
): ReturnType<typeof getFeatureFlag> {
  const state = usePatronSelector((state) => state);
  return getFeatureFlag(state, flag);
}

export default useFeatureFlag;
